import { render } from "./ConfirimEmail.vue?vue&type=template&id=30038a28&scoped=true"
import script from "./ConfirimEmail.vue?vue&type=script&lang=js"
export * from "./ConfirimEmail.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-30038a28"

export default script